// Styles
import '../scss/main.scss';

// Scripts
import { offer } from '@shop/frontend/dist/desktop/index';
import '/vendor/js/owl.carousel.min.js';

$(document).ready(function () {
  offer.getState(function (data) {
    var productPrice = window.currency || '£' + data.availableProducts[0].price.toFixed(2);

    $('.product-price').text(productPrice);

    var cmp = data.query.cmp;
    if (cmp === 'false') {
      $('.main-page').addClass('cmp-clear');
      $('.cmp-hide').hide();
    }
  });

  $('.carousel-testimonials').owlCarousel({
    items: 3,
    itemsDesktop: [1023, 3],
    itemsTablet: [960, 2],
    itemsMobile: [767, 1],
    singleItem: false,
    autoPlay: 7000,
    paginationSpeed: 1600,
    navigation: false,
    pagination: true,
    responsive: true,
    paginationNumbers: false,
    stopOnHover: false,
    mouseDrag: false,
    touchDrag: false,
  });

  $('.attention-block')
    .delay(1000)
    .slideDown('slow', function () {});
  $('.icon-close').on('click', function () {
    $('.attention-block').slideUp('slow', function () {});
  });

  $('.third-section main article.item-1 .more-button').on('click', function () {
    $('.third-section main .info').fadeOut(300);
    $('.third-section main .info.item-1').fadeIn(300);
  });
  $('.third-section main article.item-2 .more-button').on('click', function () {
    $('.third-section main .info').fadeOut(300);
    $('.third-section main .info.item-2').fadeIn(300);
  });
  $('.third-section main article.item-3 .more-button').on('click', function () {
    $('.third-section main .info').fadeOut(300);
    $('.third-section main .info.item-3').fadeIn(300);
  });
  $('.third-section main article.item-4 .more-button').on('click', function () {
    $('.third-section main .info').fadeOut(300);
    $('.third-section main .info.item-4').fadeIn(300);
  });
  $('.third-section main .info.item-1 .next-info-link').on('click', function () {
    $('.third-section main .info').fadeOut(300);
    $('.third-section main .info.item-2').fadeIn(300);
  });
  $('.third-section main .info.item-2 .next-info-link').on('click', function () {
    $('.third-section main .info').fadeOut(300);
    $('.third-section main .info.item-3').fadeIn(300);
  });
  $('.third-section main .info.item-3 .next-info-link').on('click', function () {
    $('.third-section main .info').fadeOut(300);
    $('.third-section main .info.item-4').fadeIn(300);
  });
  $('.third-section main .info .close-info-link').on('click', function () {
    $('.third-section main .info').fadeOut(300);
  });
});
